// extracted by mini-css-extract-plugin
module.exports = {"counterContainer":"HappyCustomers_counterContainer__9cz-p","customerCount":"HappyCustomers_customerCount__INX1G","description":"HappyCustomers_description__S7t63"};